export default {
  namespaced: true,
  state: () => ({
    List: [],
    activeFilter: [],
    filterList: [],
  }),
  mutations: {
    setActiveFilter(state, payload) {
      state.activeFilter = payload;
    },
    clearFilter(state) {
      state.activeFilter = [];
    },

    setFilterList(state, payload) {
      state.filterList = payload;
    },
    clearFilterList(state) {
      state.filterList = [];
    },

    addOrder(state, payload) {
      // Find if entry already exists with the same tab, page, and filter
      // Array karşılaştırması için string key kullan
      const getFilterKey = (filter) => {
        return Array.isArray(filter)
          ? filter.map(f => f.name).sort().join(',')
          : '';
      };
      const payloadFilterKey = getFilterKey(payload.filterCenter);

      const existingEntryIndex = state.List.findIndex(
        (r) =>
          r.tab === payload.tab &&
          r.page === payload.page &&
          getFilterKey(r.filterCenter) === payloadFilterKey &&
          r.tabType === payload.tabType // Include tabType in comparison
      );

      if (existingEntryIndex !== -1) {
        // Update existing entry
        state.List[existingEntryIndex] = {
          ...payload,
          date: new Date()
        };
      } else {
        // Add new entry if not found
        state.List.push({
          page: payload.page,
          data: payload.data,
          filterCenter: payload.filterCenter,
          tab: payload.tab,
          tabType: payload.tabType, // Store tab type for better distinction
          date: new Date()
        });
      }

      // Optional: Implement a more sophisticated cache management strategy
      // For example, limit entries per tab or use LRU (Least Recently Used) strategy
      const MAX_ENTRIES_PER_TAB = 10;
      
      // Group by tab
      const entriesByTab = {};
      state.List.forEach(entry => {
        if (!entriesByTab[entry.tab]) {
          entriesByTab[entry.tab] = [];
        }
        entriesByTab[entry.tab].push(entry);
      });
      
      // Keep only the most recent entries for each tab
      let newList = [];
      Object.keys(entriesByTab).forEach(tab => {
        const tabEntries = entriesByTab[tab]
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, MAX_ENTRIES_PER_TAB);
        newList = [...newList, ...tabEntries];
      });
      
      state.List = newList;
    },

    // Only clear the cache when explicitly called
    clearPage(state) {
      state.List = [];
    },
    
    // Add a more selective clear method that only clears specific tab entries
    clearTabEntries(state, tabIndex) {
      state.List = state.List.filter(entry => entry.tab !== tabIndex);
    },
  },
};